import { ChangePasswordRequest, RegisterUserRequest, UpdateProfileRequest, UserPublic } from 'api/model';
import instance from '../axios_instance';

export const getMe = async (): Promise<UserPublic> => {
  const response = await instance.get<UserPublic>('/auth/me');
  return response.data;
};

export const updateMe = async (model: UpdateProfileRequest): Promise<UserPublic> => {
  const response = await instance.patch<UserPublic>('/auth/me', model);
  return response.data;
};

export const changePassword = async (model: ChangePasswordRequest): Promise<void> => {
  await instance.put('/auth/me/password', model);
};

export const registerUser = async (model: RegisterUserRequest): Promise<UserPublic> => {
  const response = await instance.post<UserPublic>('/auth/register', model);
  return response.data;
};

export { loginRequest, logoutRequest } from './authClient';
